<app-navbar></app-navbar>

<div class="page-content">
  <router-outlet />
</div>

<app-loader></app-loader>

<p-toast />

<p-confirmdialog [draggable]="false"></p-confirmdialog>
<app-notifications-sidebar></app-notifications-sidebar>
